// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bookMagnifyingGlass16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-book-magnifying-glass': IconBookMagnifyingGlass;
    }
}

/**
 * The icon component for the 'bookMagnifyingGlass' icon
 */
export class IconBookMagnifyingGlass extends Icon {
    public constructor() {
        super(bookMagnifyingGlass16X16);
    }
}

registerIcon('icon-book-magnifying-glass', IconBookMagnifyingGlass);
export const iconBookMagnifyingGlassTag = 'nimble-icon-book-magnifying-glass';
